import { render, staticRenderFns } from "./RWCustomerShippingmark.vue?vue&type=template&id=8f1fb2d6&scoped=true&"
import script from "./RWCustomerShippingmark.vue?vue&type=script&lang=js&"
export * from "./RWCustomerShippingmark.vue?vue&type=script&lang=js&"
import style0 from "./RWCustomerShippingmark.vue?vue&type=style&index=0&id=8f1fb2d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1fb2d6",
  null
  
)

export default component.exports